module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCreative.e246807.jpg";